import { generateDialogParams } from '@/lib/generic.utils'
import { DataService } from '@api/index'
import { axiosInstance as request } from '@/api/rest.service'

const SERVICE = new DataService('products')
const getSubjectCategories = () => request.get('/subject-categories')
const createSubjectCategory = payload => request.post('/subject-categories', payload)

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCreateFormData(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.getCreateFormData()
        .then(response => {
          context.commit('updatePublishers', response.data.result.publishers)
          context.commit('updateTypes', response.data.result.types)
          context.commit('updateUsers', response.data.result.users)
          context.commit('updateMetaDataFields', response.data.result.meta_data_fields_by_category)
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  create(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.create(params)
        .then(response => {
          resolve(response.data.result)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  update(context, params) {
    return SERVICE.update(params)
      .then(response => response.data.result)
      .catch(err => err)
  },
  getInlineEditingData(context) {
    const SERVICE = new DataService(`inline-editing/data/products/product`)
    return new Promise((resolve, reject) => {
      return SERVICE.getInlineEditingData()
        .then(response => {
          context.commit(
            'data/updateInlineEditingData',
            { namespace: 'products', value: response.data.result },
            { root: true }
          )
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  getMetaDataColumns({ commit }) {
    const SERVICE = new DataService('meta-data-columns/product')

    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          commit('updateMetaDataColumns', response.data.result)
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  getProductSubscriptions(context, params) {
    let endpoint = `products/${params.id}/subscriptions`
    const SERVICE = new DataService(endpoint)
    return SERVICE.get()
      .then(response => response.data.result)
      .catch(err => err)
  },
  getSubjectCategories({ commit, state }) {
    if (state.subjectCategories) return // subject categories are already fetched
    getSubjectCategories().then(({ data }) => commit('setSubjectCategories', data.result))
  },
  createSubjectCategory({ commit }, payload) {
    return createSubjectCategory(payload).then(({ data }) => {
      commit('addSubjectCategory', data.result)
      return data.result
    })
  }
}
